import { Component } from "react"
import { Mobile, PC, Tablet, Notebook } from "../../ReactiveMode"
import { fadeInAndOut } from "../../../styles/animation"

class YouthGroup extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    fadeInAndOut()
  }

  render() {
    const logoUrl = `${process.env.REACT_APP_CDN_URL}/images/education/5.png`

    return (
        <section className="pf-page">
          <PC>
            <div className="youthgroup-clean-header animate-on-scroll fade-in">
              <div className="header-container">
                <div className="header-content">
                  <div className="header-icon">
                    <img src={logoUrl || "/placeholder.svg"} alt="디모데 청년부 로고" />
                  </div>
                  <h1>디모데 청년부</h1>
                  <p>열매 맺는 인생, 하나님 나라를 세우는 믿음의 나무</p>
                </div>
              </div>
            </div>

            <section className="youthgroup-clean-content">
              <div className="content-wrapper">
                {/* 소개 */}
                <div className="section">
                  <div className="section-header">
                    <h2>디모데 청년부 소개</h2>
                  </div>
                  <div className="intro-card animate-on-scroll fade-in">
                    <div className="card-content">
                      <div className="icon-wrapper">
                        <i className="fas fa-seedling"></i>
                      </div>
                      <div className="text-content">
                        <p className="main-text">
                          청년부는 하나님의 부르심에 응답하며 삶의 자리에서 복음의 열매를 맺는 시기입니다.
                        </p>
                        <p className="sub-text">
                          진로, 인간관계, 결단의 순간들 속에서 하나님의 뜻을 분별하고, 주님의 제자로서 세상을 향해
                          나아갑니다. 청년부는 삶과 신앙이 통합되고, 교회와 사회 속에서 하나님 나라를 세우는 견고한 믿음의
                          나무로 성장해가는 공동체입니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 표어 */}
                <div className="section">
                  <div className="section-header">
                    <h2>표어</h2>
                  </div>
                  <div className="motto-card animate-on-scroll scale-in">
                    <div className="motto-content">
                      <div className="motto-icon">
                        <i className="fas fa-dove"></i>
                      </div>
                      <h3>독수리 같이 새롭게 하소서</h3>
                    </div>
                  </div>
                </div>

                {/* 예배 안내 */}
                <div className="section">
                  <div className="section-header">
                    <h2>예배 안내</h2>
                  </div>
                  <div className="worship-grid">
                    <div className="worship-card animate-on-scroll scale-in delay-100">
                      <div className="worship-header">
                        <div className="worship-icon">
                          <i className="fas fa-church"></i>
                        </div>
                        <h3>주일 예배</h3>
                      </div>
                      <div className="worship-content">
                        <ul className="worship-details">
                          <li>
                            <i className="fas fa-clock"></i>
                            <span>주일 오후예배 (2:30) 후 소모임</span>
                          </li>
                          <li>
                            <i className="fas fa-users"></i>
                            <span>20세부터 29세까지</span>
                          </li>
                          <li>
                            <i className="fas fa-list"></i>
                            <span>교회 전체 오후예배와 동일한 순서</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 주제성구 */}
                <div className="section">
                  <div className="section-header">
                    <h2>주제성구</h2>
                  </div>
                  <div className="scripture-card animate-on-scroll rotate-in">
                    <div className="scripture-content">
                      <div className="scripture-icon">
                        <i className="fas fa-bible"></i>
                      </div>
                      <blockquote>
                        "좋은 것으로 네 소원을 만족하게 하사 네 청춘을 독수리 같이 새롭게 하시는도다"
                      </blockquote>
                      <cite>시편 103:5</cite>
                    </div>
                  </div>
                </div>

                {/* 교육목표 */}
                <div className="section">
                  <div className="section-header">
                    <h2>교육목표</h2>
                  </div>
                  <div className="goals-grid">
                    <div className="goal-card animate-on-scroll slide-in-left delay-100">
                      <div className="goal-icon">
                        <i className="fas fa-compass"></i>
                      </div>
                      <h3>거룩한 비전과 소명 발견</h3>
                      <p>자신의 삶을 향한 하나님의 뜻을 분별하고, 신앙 안에서 바른 꿈과 방향을 세우도록 이끕니다.</p>
                    </div>
                    <div className="goal-card animate-on-scroll slide-in-up delay-200">
                      <div className="goal-icon">
                        <i className="fas fa-praying-hands"></i>
                      </div>
                      <h3>기도를 통한 인격적 교제</h3>
                      <p>간절한 기도와 말씀 묵상을 통해 하나님과의 관계를 깊이 있게 다져가도록 격려합니다.</p>
                    </div>
                    <div className="goal-card animate-on-scroll slide-in-right delay-300">
                      <div className="goal-icon">
                        <i className="fas fa-heart"></i>
                      </div>
                      <h3>성령의 은사와 열매 실천</h3>
                      <p>성령의 능력으로 변화된 삶을 살아가고, 공동체와 세상 속에서 복음의 열매를 맺도록 훈련합니다.</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </PC>

          <Notebook>
            <div className="youthgroup-clean-header animate-on-scroll fade-in">
              <div className="header-container">
                <div className="header-content">
                  <div className="header-icon">
                    <img src={logoUrl || "/placeholder.svg"} alt="디모데 청년부 로고" />
                  </div>
                  <h1>디모데 청년부</h1>
                  <p>열매 맺는 인생, 하나님 나라를 세우는 믿음의 나무</p>
                </div>
              </div>
            </div>

            <section className="youthgroup-clean-content">
              <div className="content-wrapper">
                {/* 소개 */}
                <div className="section">
                  <div className="section-header">
                    <h2>디모데 청년부 소개</h2>
                  </div>
                  <div className="intro-card animate-on-scroll fade-in">
                    <div className="card-content">
                      <div className="icon-wrapper">
                        <i className="fas fa-seedling"></i>
                      </div>
                      <div className="text-content">
                        <p className="main-text">
                          청년부는 하나님의 부르심에 응답하며 삶의 자리에서 복음의 열매를 맺는 시기입니다. 진로, 인간관계,
                          결단의 순간들 속에서 하나님의 뜻을 분별하고, 주님의 제자로서 세상을 향해 나아갑니다.
                        </p>
                        <p className="sub-text">
                          청년부는 삶과 신앙이 통합되고, 교회와 사회 속에서 하나님 나라를 세우는 견고한 믿음의 나무로
                          성장해가는 공동체입니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 표어 */}
                <div className="section">
                  <div className="section-header">
                    <h2>표어</h2>
                  </div>
                  <div className="motto-card animate-on-scroll scale-in">
                    <div className="motto-content">
                      <div className="motto-icon">
                        <i className="fas fa-dove"></i>
                      </div>
                      <h3>독수리 같이 새롭게 하소서</h3>
                    </div>
                  </div>
                </div>

                {/* 예배 안내 */}
                <div className="section">
                  <div className="section-header">
                    <h2>예배 안내</h2>
                  </div>
                  <div className="worship-grid notebook-worship-info">
                    <div className="worship-card animate-on-scroll scale-in delay-100">
                      <div className="worship-header">
                        <div className="worship-icon">
                          <i className="fas fa-church"></i>
                        </div>
                        <h3>주일 예배</h3>
                      </div>
                      <div className="worship-content">
                        <ul className="worship-details">
                          <li>
                            <i className="fas fa-clock"></i>
                            <span>주일 오후예배 (2:30) 후 소모임</span>
                          </li>
                          <li>
                            <i className="fas fa-users"></i>
                            <span>20세부터 29세까지</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 주제성구 */}
                <div className="section">
                  <div className="section-header">
                    <h2>주제성구</h2>
                  </div>
                  <div className="scripture-card animate-on-scroll rotate-in">
                    <div className="scripture-content">
                      <div className="scripture-icon">
                        <i className="fas fa-bible"></i>
                      </div>
                      <blockquote>
                        "좋은 것으로 네 소원을 만족하게 하사 네 청춘을 독수리 같이 새롭게 하시는도다"
                      </blockquote>
                      <cite>시편 103:5</cite>
                    </div>
                  </div>
                </div>

                {/* 교육목표 */}
                <div className="section">
                  <div className="section-header">
                    <h2>교육목표</h2>
                  </div>
                  <div className="goals-grid notebook-goals-grid">
                    <div className="goal-card animate-on-scroll slide-in-left delay-100">
                      <div className="goal-icon">
                        <i className="fas fa-compass"></i>
                      </div>
                      <h3>거룩한 비전과 소명 발견</h3>
                      <p>자신의 삶을 향한 하나님의 뜻을 분별하고, 신앙 안에서 바른 꿈과 방향을 세우도록 이끕니다.</p>
                    </div>
                    <div className="goal-card animate-on-scroll slide-in-up delay-200">
                      <div className="goal-icon">
                        <i className="fas fa-praying-hands"></i>
                      </div>
                      <h3>기도를 통한 인격적 교제</h3>
                      <p>간절한 기도와 말씀 묵상을 통해 하나님과의 관계를 깊이 있게 다져가도록 격려합니다.</p>
                    </div>
                    <div className="goal-card animate-on-scroll slide-in-right delay-300">
                      <div className="goal-icon">
                        <i className="fas fa-heart"></i>
                      </div>
                      <h3>성령의 은사와 열매 실천</h3>
                      <p>성령의 능력으로 변화된 삶을 살아가고, 공동체와 세상 속에서 복음의 열매를 맺도록 훈련합니다.</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Notebook>

          <Tablet>
            <div className="youthgroup-clean-header animate-on-scroll fade-in">
              <div className="header-container">
                <div className="header-content">
                  <div className="header-icon">
                    <img src={logoUrl || "/placeholder.svg"} alt="디모데 청년부 로고" />
                  </div>
                  <h1>디모데 청년부</h1>
                  <p>열매 맺는 인생, 하나님 나라를 세우는 믿음의 나무</p>
                </div>
              </div>
            </div>

            <section className="youthgroup-clean-content">
              <div className="content-wrapper">
                {/* 소개 */}
                <div className="section">
                  <div className="section-header">
                    <h2>디모데 청년부 소개</h2>
                  </div>
                  <div className="intro-card animate-on-scroll fade-in">
                    <div className="card-content">
                      <div className="icon-wrapper">
                        <i className="fas fa-seedling"></i>
                      </div>
                      <div className="text-content">
                        <p className="main-text">
                          청년부는 하나님의 부르심에 응답하며 삶의 자리에서 복음의 열매를 맺는 시기입니다. 진로, 인간관계,
                          결단의 순간들 속에서 하나님의 뜻을 분별하고, 주님의 제자로서 세상을 향해 나아갑니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 표어 */}
                <div className="section">
                  <div className="section-header">
                    <h2>표어</h2>
                  </div>
                  <div className="motto-card animate-on-scroll scale-in">
                    <div className="motto-content">
                      <div className="motto-icon">
                        <i className="fas fa-dove"></i>
                      </div>
                      <h3>독수리 같이 새롭게 하소서</h3>
                    </div>
                  </div>
                </div>

                {/* 예배 안내 */}
                <div className="section">
                  <div className="section-header">
                    <h2>예배 안내</h2>
                  </div>
                  <div className="worship-grid tablet-worship-info">
                    <div className="worship-card animate-on-scroll scale-in delay-100">
                      <div className="worship-header">
                        <div className="worship-icon">
                          <i className="fas fa-church"></i>
                        </div>
                        <h3>주일 예배</h3>
                      </div>
                      <div className="worship-content">
                        <ul className="worship-info">
                          <div className="info-item">
                            <i className="fas fa-clock"></i>
                            <span>주일 오후예배 (2:30) 후 소모임</span>
                          </div>
                          <div className="info-item">
                            <i className="fas fa-users"></i>
                            <span>20세부터 29세까지</span>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 주제성구 */}
                <div className="section">
                  <div className="section-header">
                    <h2>주제성구</h2>
                  </div>
                  <div className="scripture-card animate-on-scroll rotate-in">
                    <div className="scripture-content">
                      <div className="scripture-icon">
                        <i className="fas fa-bible"></i>
                      </div>
                      <blockquote>
                        "좋은 것으로 네 소원을 만족하게 하사 네 청춘을 독수리 같이 새롭게 하시는도다"
                      </blockquote>
                      <cite>시편 103:5</cite>
                    </div>
                  </div>
                </div>

                {/* 교육목표 */}
                <div className="section">
                  <div className="section-header">
                    <h2>교육목표</h2>
                  </div>
                  <div className="goals-grid tablet-goals-grid">
                    <div className="goal-card animate-on-scroll slide-in-left delay-100">
                      <div className="goal-icon">
                        <i className="fas fa-compass"></i>
                      </div>
                      <h3>거룩한 비전과 소명 발견</h3>
                      <p>자신의 삶을 향한 하나님의 뜻을 분별하고, 신앙 안에서 바른 꿈과 방향을 세우도록 이끕니다.</p>
                    </div>
                    <div className="goal-card animate-on-scroll slide-in-up delay-200">
                      <div className="goal-icon">
                        <i className="fas fa-praying-hands"></i>
                      </div>
                      <h3>기도를 통한 인격적 교제</h3>
                      <p>간절한 기도와 말씀 묵상을 통해 하나님과의 관계를 깊이 있게 다져가도록 격려합니다.</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Tablet>

          <Mobile>
            <div className="youthgroup-clean-header animate-on-scroll fade-in">
              <div className="header-container">
                <div className="header-content">
                  <div className="header-icon">
                    <img src={logoUrl || "/placeholder.svg"} alt="디모데 청년부 로고" />
                  </div>
                  <h1>디모데 청년부</h1>
                  <p>열매 맺는 인생, 하나님 나라를 세우는 믿음의 나무</p>
                </div>
              </div>
            </div>

            <section className="youthgroup-clean-content">
              <div className="content-wrapper">
                {/* 소개 */}
                <div className="section">
                  <div className="section-header">
                    <h2>디모데 청년부 소개</h2>
                  </div>
                  <div className="intro-card animate-on-scroll fade-in">
                    <div className="card-content">
                      <div className="icon-wrapper">
                        <i className="fas fa-seedling"></i>
                      </div>
                      <div className="text-content">
                        <p className="main-text">
                          청년부는 하나님의 부르심에 응답하며 삶의 자리에서 복음의 열매를 맺는 시기입니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 표어 */}
                <div className="section">
                  <div className="section-header">
                    <h2>표어</h2>
                  </div>
                  <div className="motto-card animate-on-scroll scale-in">
                    <div className="motto-content">
                      <div className="motto-icon">
                        <i className="fas fa-dove"></i>
                      </div>
                      <h3>독수리 같이 새롭게 하소서</h3>
                    </div>
                  </div>
                </div>

                {/* 예배 안내 */}
                <div className="section">
                  <div className="section-header">
                    <h2>예배 안내</h2>
                  </div>
                  <div className="worship-grid mobile-worship-info">
                    <div className="worship-card animate-on-scroll scale-in delay-100">
                      <div className="worship-header">
                        <div className="worship-icon">
                          <i className="fas fa-church"></i>
                        </div>
                        <h3>주일 예배</h3>
                      </div>
                      <div className="worship-content">
                        <ul className="worship-info">
                          <div className="info-item">
                            <i className="fas fa-clock"></i>
                            <span>주일 오후예배 (2:30) 후 소모임</span>
                          </div>
                          <div className="info-item">
                            <i className="fas fa-users"></i>
                            <span>20세부터 29세까지</span>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 주제성구 */}
                <div className="section">
                  <div className="section-header">
                    <h2>주제성구</h2>
                  </div>
                  <div className="scripture-card animate-on-scroll rotate-in">
                    <div className="scripture-content">
                      <div className="scripture-icon">
                        <i className="fas fa-bible"></i>
                      </div>
                      <blockquote>
                        "좋은 것으로 네 소원을 만족하게 하사 네 청춘을 독수리 같이 새롭게 하시는도다"
                      </blockquote>
                      <cite>시편 103:5</cite>
                    </div>
                  </div>
                </div>

                {/* 교육목표 */}
                <div className="section">
                  <div className="section-header">
                    <h2>교육목표</h2>
                  </div>
                  <div className="goals-grid mobile-goals-grid">
                    <div className="goal-card animate-on-scroll slide-in-left delay-100">
                      <div className="goal-icon">
                        <i className="fas fa-compass"></i>
                      </div>
                      <h3>거룩한 비전과 소명 발견</h3>
                      <p>자신의 삶을 향한 하나님의 뜻을 분별하고, 신앙 안에서 바른 꿈과 방향을 세우도록 이끕니다.</p>
                    </div>
                    <div className="goal-card animate-on-scroll slide-in-up delay-200">
                      <div className="goal-icon">
                        <i className="fas fa-praying-hands"></i>
                      </div>
                      <h3>기도를 통한 인격적 교제</h3>
                      <p>간절한 기도와 말씀 묵상을 통해 하나님과의 관계를 깊이 있게 다져가도록 격려합니다.</p>
                    </div>
                    <div className="goal-card animate-on-scroll slide-in-right delay-300">
                      <div className="goal-icon">
                        <i className="fas fa-heart"></i>
                      </div>
                      <h3>성령의 은사와 열매 실천</h3>
                      <p>성령의 능력으로 변화된 삶을 살아가고, 공동체와 세상 속에서 복음의 열매를 맺도록 훈련합니다.</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Mobile>
        </section>
    )
  }
}

export default YouthGroup
